import ValueGeneratorInterface from "./ValueGeneratorInterface"
import FactorialValue from "../../Model/Value/FactorialValue"
import NumberValue from "../../Model/Value/NumberValue"

export default class FactorialValueGenerator implements ValueGeneratorInterface {
  public supports(value: number): boolean {
    return this.getBase(value) !== undefined
  }

  public generate(value: number): FactorialValue {
    const factorialValue: number | undefined = this.getBase(value)
    if (factorialValue === undefined) {
      throw new Error(
        `FactorialValueGenerator: factorialValue must be a number`,
      )
    }

    return new FactorialValue(new NumberValue(factorialValue))
  }

  private getBase(n: number): number | undefined {
    if (n < 1) {
      return undefined
    }

    let x: number = n
    let k: number = 2

    while (x > 1) {
      if (x % k !== 0) {
        return undefined
      }
      x /= k
      k++
    }

    return k - 1
  }
}
